import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'
import { isProp, onMobile } from '../utils/selector'

interface Props {
  primary?: boolean
}

export const PrimitiveLink = styled.a`
  text-decoration: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  border: 1px solid #1a6ba1;
  color: currentColor;
  padding: 8px 2vw;
  text-align: center;

  ${onMobile} {
    padding: 8px 16px;
  }

  ${isProp<Props>('primary')} {
    color: white;
    border: none;
    background: linear-gradient(
        90deg,
        rgba(204, 224, 244, 0.55) 1.15%,
        rgba(255, 255, 255, 0) 98.08%
      ),
      #005b97;
  }

  &::after {
    content: '>';
    margin-left: 0.5em;
  }

  &:hover {
    color: white;
    background: linear-gradient(
        90deg,
        rgba(204, 224, 244, 0.55) 1.15%,
        rgba(255, 255, 255, 0) 98.08%
      ),
      #005b97;
  }
`

const Link = PrimitiveLink.withComponent(GatsbyLink)

export default Link
